import React from 'react';
import Logo from './Logo.png';

// Styles
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh'
  },
});

export default (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img src={Logo} alt={"Pollbarn.io"} width={100} />
    </div>
  );
}
